import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import './MoreActions.scss';
function MoreActions(_ref) {
  var listItems = _ref.listItems;
  return /*#__PURE__*/React.createElement(DropdownButton, {
    variant: "more-options",
    title: "More Actions",
    id: "more-options-dropdown"
  }, listItems.map(function (item, i) {
    return /*#__PURE__*/React.createElement(Dropdown.Item, {
      as: "li",
      key: "item-".concat(i),
      role: "presentation"
    }, item);
  }));
}
MoreActions.propTypes = {
  listItems: PropTypes.arrayOf(PropTypes.element).isRequired
};
MoreActions.defaultProps = {};
export default MoreActions;